const EXACT_CONSTANT = "!!";

export const notApplicableCouponMessages = [
  // English — added from the unrecognised-failure review. Each of these had a
  // longer sibling already on this list; the shorter form a site actually
  // renders was slipping through and landing in the review queue.
  "cannot be applied to your cart",
  "does not apply to any items in your cart",
  "not apply to any items in your cart",
  // English
  "not valid for the items in your cart",
  "valid for the items in your cart",
  "not applicable to your cart",
  "not applicable on this product",
  "does not apply to these items",
  "applies only to certain items",
  "not valid on sale items",
  "not valid for selected products",
  "not valid on discounted items",
  "does not qualify for this promotion",
  "not combinable with current offers",
  "not applicable to selected products",
  "the minimum spend for",
  "minimum spend for coupon",
  "cart hasn't met the conditions set",
  "couldn't be applied to any items in your order",
  "is valid but not applicable",
  "valid for the items in your bag",
  "minimum quantity of matching products for this coupon is",
  "will be applied when its conditions are met",
  "this coupon cannot be applied to this item",
  "maximum spend for coupon",
  "is not applicable to the categories",
  "is not applicable to the category",
  "not valid for sale items",
  "qualifying items in cart",
  "minimum quantity of matching products for this",
  "move eligible number of products in the cart to redeem the coupon",
  "discount code has not met minimum requirements",
  "has already been applied and cannot be used in conjunction with other coupons",
  "coupon cannot be used in combination with other discounts",
  "discount code isn't valid on BOGO items",
  "isn't valid for the items in your basket",
  "is not eligible for items in your cart",
  "you have not met the minimum requirements for this code",
  "cart does not meet the requirements",
  "isn’t valid for the items in your basket",
  "shipping discounts are applied when applicable threshold is met after discounts",
  "discount code isn't valid for bundles or sale items",
  "isn't valid for the items or quantity in your cart",
  "will be applied when conditions are met",
  "code only valid for regular-priced items",
  "code isn't valid for the items or plans (subscriptions) in your cart",
  "not eligible for additional discount",
  "is valid, but the item(s) in your cart do not qualify",
  "codes are not valid during sales",
  "some discount codes couldn't be used together",
  "some discounts could not be combined",
  "add additional products to cart for",
  "codes cannot be applied towards",
  "isn't valid on the items in your bag",
  "discount codes cannot be used on already discounted products",
  "could not be applied because your subtotal is less than",
  "you’re getting the best deal during the",
  "cannot be applied as the requirements have not been met",
  "Your basket does not meet the requirements",
  "discount cannot be combined with",
  "please choose at least",
  "promo code is ineligible for the basket contents",
  "your order does not meet the condition",
  "combos and special offers are already at their best prices",
  "does not apply to already discounted products and gift cards",
  "coupon is valid but does not",
  "your order total must be at least",
  "your order does not contain any products that qualify",
  "couldn't be used with your existing discounts",
  "available upon login",
  "more to avail this offer",
  "cart total must be at least",
  "login before applying this coupon code",
  "can only be used for orders above",
  "only valid on orders above",
  "cart contains a product from an excluded category that prevents this coupon code from being applied",
  "basket is not eligible for the specified coupon",
  "discount code you entered only applies if you are signed in",
  "minimum order value for this promo code",
  "only to orders with a subtotal amount of at least",
  "only valid on orders over",
  "subtotal must be equals or greater than",
  "has not been met",
  "log in before using this discount",
  "minimum purchase of",
  "must have an order with a minimum of",
  "cannot use this voucher with these products",
  "minimum order value of",
  "cannot redeem this offer code with these products",
  "cart does not qualify for this coupon",
  "does not currently meet the requirements",
  "code you have used is not applicable to the contents of your cart",
  "promo code requires a",
  "is valid only for plus users",
  "don't meet our condition",
  "applied but not valid for items in this basket",
  "promo-code gilt für Bestellungen ab",
  "is valid, but not applicable",
  "promo won't take effect until one or more products from",
  "more to the cart to avail this offer",
  "more to meet coupon usage requirements",
  "ineligible for your items in your shopping cart",
  "doesn't qualify for this discount",
  "minimum order value too low",
  "minimum spend for this voucher is",
  "must have an active product/service",
  "no eligible items",
  "no items in your cart that qualify",
  "no items qualify for the discount",
  "not applicable to selected product",
  "not applicable to the selected products",
  "code isn't valid for items in your cart",
  "code isn't valid for the items in your order",
  "total is lower than the amount required",
  "voucher is invalid for current shopping cart",
  "will be applied when eligible conditions are met",
  "[CODE] is not applicable on the products in your basket",
  "does not meet the requirements for the [CODE] discount code",
  "codes cannot be used during sitewide sales",
  "discount code isn’t valid for the items in your order",
  "code is not valid for items in your cart",
  "select more products in your cart to fulfill the minimum purchase criteria",
  "order cannot be combined with other promotions",
  "your cart is not eligible for the specified coupon",
  "codes cannot be applied to marketplace products",
  "coupon cannot be applied as it requires a minimum order total of",
  "your shopping cart subtotal must be at least",
  "you need to purchase \\$\\d+(\\.\\d{2})? to use this discount code",
  "add (us)?\\$\\d+(\\.\\d{2})? more, you can use this coupon",
  "discount code you have used is not applicable to the contents of your basket",
  "order does not qualify for",
  'Coupon code "[CODE]" is not applicable to any of the items in this cart',
  "minimum order value was not reached",
  "there is a minimum order of £\\d+(\\.\\d{2})? in order to use this voucher",
  "Spend A\\$\\d+(\\.\\d{2})? more to receive your free delivery",
  "Minimum product spend of £\\d+(\\.\\d{2})? not met",
  `Coupon code "[CODE]" is not applicable to any of the items in this cart`,
  "the discount code you have used is not applicable to the contents of your basket",
  "Offer will work on base price only",
  "there are no items in your shopping cart for which this gift voucher is valid",
  "requires you to purchase AUD \\$\\d+(\\.\\d{2})? or more from",
  "the discount code [CODE] is valid but your bag must total at least",
  "discount code is valid but is not applicable with the items in your bag",
  "coupon condition is not met",
  "Spend \\$\\d+(\\.\\d{2})? and receive free lip balm",
  "code [CODE] is limited to two uses per customer",
  "only applies to specific departments",
  "minimum value required for this code hasn't been reached yet",
  "bag does not yet meet the minimum order value",
  "won't take effect until one or more products from the following brands are added to the cart",
  "promotion code requires a minimum order amount",
  "cart is not yet eligible for this coupon",
  "Only valid on orders \\$\\d+(\\.\\d{2})?",
  "Only valid on orders with d+ or more items",
  "this coupon can only be used on a subscription",
  "this coupon doesn't apply to any of the products in your cart",
  "discount valid only on",
  "add just \\$\\d+(\\.\\d{2})? to your order to qualify for this promotional discount",
  "Minimum purchase amount not met for [CODE]",
  "but this code requires you to have some specific product in your cart",
  "this coupon code is only valid when you are logged in",
  "minimum subtotal of $\\d+(\\.\\d{2})? is required for this coupon",
  "you must be logged in to use this discount",
  `${EXACT_CONSTANT}the items in your cart do not qualify for this coupon.`,
  "coupon can only be used on merchandise subtotal over $\\d+(\\.\\d{2})?",
  "discount coupon [CODE] is not applicable for any item in cart",
  "items in your cart do not qualify for this offer",
  "we're unable to apply the code entered, as it is either invalid or the order value is lower than the voucher threshold",
  "the minimum subtotal of \\$\\d+(\\.\\d{2})? is required for this coupon",
  "code does not apply to any items in this cart",
  "code can't be applied on top of the discount you already have - would you like to apply this discount instead",
  "Your discount is now ACTIVE. Add products to your cart and checkout to see the discount activated automatically!",
  "% OFF unlocked. Thanks for supporting our trusted partner.",
  "this coupon code can't be applied to orders less than or equal to \\$\\d+(\\.\\d{2})?",
  "item is excluded from the applied promotion code",
  "product not eligible for this discount code",
  "eligible item total has to be greater than \\$\\d+(\\.\\d{2})?",
  "Minimum amount: £ \\d+(\\.\\d{2})?",
  "[CODE] could not be applied as it is only valid for first-time loyalty customers",
  "you must login to your existing account, or register a new account, before you can use this discount code",
  "enter a valid discount code reduction code couldn't be mapped to a discount code.",
  // Added 2026-09-30. All say the code is fine but this order cannot take it —
  // one-per-order limits, wrong items, unmet thresholds. Counting these as
  // failures would back off codes that work.
  "number of coupon codes exceeds the limit",
  "coupon per order",
  "apply more discount codes",
  "be used with one or more of the items currently in your basket",
  "applied for the items in cart",
  "does not meet the discount requirements",
  "discount codes exceed quantity limit",

  // German
  "in deinem warenkorb nicht gültig",
  "nicht für die artikel in deinem warenkorb gültig",
  "gilt nicht für ausgewählte artikel",
  "nicht anwendbar auf diese produkte",
  "nicht für reduzierte ware gültig",
  "nicht mit anderen aktionen kombinierbar",
  "für diese produktart nicht gültig",
  "für bestimmte produkte gültig",
  "im warenkorb liegen müssen",
  "geldt niet voor de artikelen in je winkelwagen",
  "niet geldig voor deze producten",
  "nicht auf die ausgewählten produkte anwendbar",
  "ist gültig, aber nicht anwendbar",
  "ist für die Artikel in Ihrem Warenkorb nicht gültig",
  "dieser gutscheincode ist während der Black Week nicht einlösbar",
  "da der Wert Ihres Warenkorbs unter",
  "ist nicht gültig für die artikel in ihrem warenkorb",
  "mindestbestellwert zu klein",
  "da die Voraussetzungen dafür nicht zutreffen",
  "mindestbestellwert noch nicht erreicht",
  "der gutschein-code wurde gespeichert",
  "da die Summe der grün markierten Artikel zu gering ist",
  "der gesamtwert ihrer bestellung ist nicht hoch genug",
  "kein passendes produkt zu dem kupon/gutschein in ihrem warenkorb",
  "einkaufswert ist zu niedrig für diesen gutschein",
  "der mindestumsatz für diesen Gutschein beträgt",
  "konnte nicht angewendet werden, da der Wert ihres warenkorbs unter",
  "der mindestbetrag für diesen gutschein ist",
  "ihrer nicht ausgeschlossenen Artikel muss den Mindestbestellwert von",
  "gutschein ist erst ab einem Bestellwert von",
  "dir fehlen noch €\\d+(\\,\\d{2})? damit das Paket kostenlos zu dir kommt",
  "gutschein kann nicht eingelöst werden, da sich nur preisgebundene bücher im warenkorb befinden",
  "[CODE] konnte nicht mit deinen vorhandenen Rabatten verwendet werden",

  // French
  "non applicable à votre panier",
  "ne s’applique pas aux articles de votre panier",
  "non valable sur cet article",
  "offre non valable pour ce produit",
  "minimum pour utiliser ce coupon",
  "peut pas être appliqué à ce produit",
  "avant que le code de réduction devienne valide",
  "est valide, mais non applicable",
  "n’est pas valide pour les articles de votre panier",
  "ce code promotionnel n'est pas applicable aux produits sélectionnés",
  "le code promotionnel saisi est valide mais ne peut pas être appliqué à votre commande",
  "car les conditions ne sont pas remplies",
  "vous ne pouvez pas utiliser ce bon de réduction avec ces produits",
  "plus que \\d+(\\,\\d{2})?€ pour bénéficier de ce code promo",

  // Spanish
  "no es válido para los artículos en tu carrito",
  "no aplicable a tu pedido",
  "no válido en productos seleccionados",
  "este código no se aplica a ningún producto en tu carrito",
  "no se puede aplicar a los productos seleccionados",
  "este cupón no es aplicable a las catagorías",
  "no es válido para los artículos de tu carrito",
  "es válido, pero no se puede aplicar",
  "el mínimo gastado para el cupón",

  // Portuguese
  "este cupom não pode ser aplicado a pedidos menores ou iguais a",
  "este cupom não é aplicável aos produtos selecionados",
  "não é válido para os itens do carrinho",
  "[CODE] é válido, mas não aplicável. verifique os termos de desconto",
  "of je winkelmandje de minimale bestelwaarde voor het gebruik van de promocode heeft bereikt",

  // Italian
  "non valido per gli articoli nel carrello",
  "non applicabile a questo prodotto",
  "offerta non valida per questo ordine",
  "è valido ma non applicabile",
  "non è valido per gli articoli nel carrello",
  "soglia minima di spesa del prodotto non raggiunta",
  "non hai raggiunto l'ammontare minimo richiesto per utilizzare questo buono",

  // Dutch
  "niet geldig voor de artikelen in je winkelwagen",
  "niet van toepassing op deze producten",

  // Optional mild/ambiguous but mostly safe
  "doesn't apply to any items in your cart",
  "no applicable items in cart",

  // Russian
  "hе выполнены условия для применения промокода",
];

export const confirmedCouponFailures = [
  // ── Added 2026-09-30 from a day of live results ──────────────────────────
  // These were landing in no bucket at all: not applied, not
  // not-applicable-to-basket, not a system error, and not matched here. That
  // left 1,880 results on 30 Sep classified as "unrecognised" when 1,108 of
  // them were the site saying, in plain words, that the code is invalid.
  //
  // `stringCompare` is a substring match, so this one entry also covers the
  // longer Shopify variants: "Enter a valid discount code or gift card" and
  // "...or gift card Reduction code couldn't be mapped to neither a gift card
  // nor a discount code". `notApplicableCouponMessages` already holds a NEAR
  // MISS of that last one ("mapped to a discount code", without the "neither"),
  // which is why it never matched — and not-applicable is checked BEFORE this
  // list, so a genuinely basket-related message still wins.
  "enter a valid discount code",
  "please enter valid coupon code",
  // Second pass, same day, over what was still unmatched after the entries
  // above. Each was verified against all three lists first — none matched
  // anything, so none of these change an existing verdict.
  "valid promo or rewards code",
  "this coupon code cannot be used",
  "couldn't be applied to your order",
  "enter a valid coupon code",
  "discount is invalid",
  "coupon is either invalid, expired",
  // Shopify again, a different wording from the one above: this variant opens
  // "Hmm, that code..." so it never contains "enter a valid discount code".
  // Distinct from the notApplicable entry "mapped to A discount code".
  "be mapped to neither a gift card",

  // German
  "coupon-code ist ungültig",
  "gutscheincode ist falsch",

  // English
  "one or more coupons failed to apply",
  "coupon is no longer valid",
  "cannot be applied because it does not exist",
  "does not exist",
  "this coupon has expired",
  "coupon is no longer valid",
  "has expired",
  "is not valid or may be expired",
  "you entered is not valid",
  "enter a valid promo code, gift card or store credit",
  "enter a valid gift card",
  "isn’t valid or may have expired",
  "did not match any active gift card or discount",
  "invalid code",
  "code does not apply or is not currently valid",
  "code is not valid",
  "enter a valid promotion code or gift card",
  "it looks like your discount didn’t apply",
  "enter a valid promo code",
  "coupon is not valid",
  "is not valid",
  "coupon code is not valid",
  "is+not+valid",
  "Coupon does not apply",
  "Invalid discount code",
  "code that you entered was not found",
  "not Applied",
  "invalid promo code",
  "code you entered is no longer valid",
  "code doesn't exist",
  "code not recognised",
  "coupon codes could not be applied",
  "code is not recognised",
  "invalid or expired Code",
  "expired Code",
  "discount code expired",
  "code is expired or inactive now",
  "code not found",
  "coupon code isn't valid",
  "code isn't valid",
  "code is invalid",
  "code is expired",
  "code you entered doesn't exist",
  "entered an invalid coupon code",
  "do discount applied",
  "invalid coupon code",
  `${EXACT_CONSTANT}invalid Coupon`,
  "discount not valid",
  "code is no longer valid",
  "code not valid",
  "code already redeemed",
  "code cannot be added to your cart",
  "code isn't right",
  "coupon expired",
  "enter a valid code",
  "invalid promo",
  "coupon has had the maximum redemptions available",
  "can't locate that coupon or coupon is expired",
  "not a valid promo code",
  "not one of our codes",
  "discount has reached its usage limit",
  "promo code incorrect",
  "not applicable for this departure, expired or invalid",
  "[CODE] not available",
  "code expired",
  "coupon can't be added to your cart",
  "coupon cannot be added to your cart",
  "coupon code could not be applied",
  "coupon not valid",
  "discount deactivated",
  "does not exist",
  "error applying discount code",
  "!!expired",
  "invalid coupon code",
  "invalid discount",
  "invalid discount voucher",
  `${EXACT_CONSTANT}invalid`, // !! in the string means it must fully equal to this value
  "no discount applied",
  "no valid voucher was found",
  "coupon could not be added to cart",
  "voucher is not valid",
  "you canceled the coupon code",
  "[CODE] is no longer valid",
  "[CODE] is not currently active",
  "[CODE] is not valid",
  "appears to be invalid",
  "cannot be accepted",
  "cannot be added to the cart",
  "code [CODE] is unknown",
  "code could not be applied",
  "code is invalid",
  "coupon not active",
  "discount code has been removed",
  "code invalid",
  "does not exist",
  "limit for coupon has been reached",
  "no applicable promotion",
  "no longer valid",
  "not a valid discount code",
  "we could not find yout voucher",
  '"[CODE]" is unknown',
  "[CODE] discount code is not valid",
  `${EXACT_CONSTANT}INVALID`,
  `Coupon code '[CODE]' could not be applied`,
  "please enter a valid promotional code",
  "the promotional code you are claiming expired on",
  "we don’t recognise this discount code",
  "discount code does not appear to be valid",
  `${EXACT_CONSTANT}Code Not Eligible.`,
  "coupon is not yet available or has already expired",
  "enter valid gift card number or coupon code",
  `Coupon code "[CODE]" cannot currently be added to your cart`,
  'Promo code "[CODE]" could not be found',
  "[CODE] is invalid",
  "Coupon [CODE] expired on",
  "coupon code [CODE] is wrong",
  "code you entered is invalid",
  "this code has reached its maximum number of uses",
  "eCoupon [CODE] is not eligible.",
  "Discount Expired: [CODE]",
  'promotion code "[CODE]" is expired',
  "promo code '[CODE]' was not found",

  // German
  "Der gutschein kann nicht dem warenkorb hinzugefügt werden",
  "ist abgelaufen",
  "gib einen gültigen Rabattcode ein",
  "der gutschein ist ungültig",
  "nie istnieje",
  "gib einen gültigen rabattcode oder gutschein ein",
  "geben sie einen gültigen rabattcode oder geschenkgutschein ein",
  "kann nicht angewendet werden, da er nicht existiert",
  "existiert nicht",
  "Kupon ist nicht aktiv",
  "gutschein abgelaufen",
  "ist nicht korrekt",
  "der angeforderte zusätzliche Code-Rabatt wurde verworfen",
  "voer een geldige kortingscode of cadeaubon in",
  "dieser gutscheincode ist leider ungültig",
  "gutschein ungültig! bitte Wert angeben",
  "ihr coupon ist bereits abgelaufen",
  "kortingscode kan niet worden ingesteld",
  "kupon ist nicht mehr gültig",
  "gutschein konnte nicht gefunden werden oder ist nicht mehr gültig",

  // French
  "ce bon de réduction a expiré",

  // Spanish
  "introduce un código de descuento válido",
  "tu código promocional no ha sido aceptado",
  "il tuo codice promozionale non è stato accettato",
  "introduce un código de descuento o tarjeta de regalo válido",
  "inserisci un codice di sconto valido",
  "inserisci un codice sconto o un buono regalo valido",
  "saisir un code de réduction valide",
  "expirado",
  "insira um código de desconto ou cartão-presente válido",
  "no es válido",
  "este cupón ha caducado",
  "é inválido",
  "ha caducado",
  "no se puede aplicar porque no existe",
  "cupón no puede añadirse a la cesta",
  "este cupón de descuento está desactivado",
  "cupon no existe",
  "cupón no válido",
  "is onbekend",
  "kod är ogiltigt",
  "este cupón no se puede agregar a la cesta",
  "non applicato",
  "voer een geldige kortingscode in",
  "code promotionnel invalide",

  // Portuguese
  "evoerde code is niet meer geldig/is niet actief. Voer een andere code in",
  "code wordt niet herkend",

  // French
  "je promotie code is niet geaccepteerd",
  "entrez un code de réduction ou une carte-cadeau valide",
  "n’est pas valide",
  "est pas valide",
  "code promotionnel est invalide",
  "ce bon de réduction n'est pas valable",
  "le code de réduction ne peut pas être appliqué à votre panier",
  "Le code n° [CODE] est incorrect ou n'est plus valide",
  "de bon de réduction non valable",
  "ce bon de réduction est désactivé",

  // Italian
  "coupon non può essere aggiunto al carrello",
  "il codice coupon non è valido",
  "non è valido",
  "il codice promozionale non può essere aggiunto al carrello",
  "coupon scaduto",
  "questo voucher non esiste",

  // Polish
  "niepoprawny kod rabatowy",
  "nieprawidłowy kod Sprawdź jego poprawność",

  // Russian
  "Промокод не действует",
  "купон либо недействителен, либо истек срок его действия, либо достигнут предел его использования",
];

export const knownCouponSuccessMessages = [
  // English
  "Coupon code applied",
  "added coupon code",
  "promotion applied",
  "discount successfully applied",
  "coupon has been applied",
  "discount applied successfully",
  "coupon has been successfully added",
  "% extra discount",
  "code has been applied",
  "code has been accepted",
  "coupon code already applied",
  "discount codes ok",
  "thanks to code [CODE]",
  "promo applied",
  "VALID discount will be applied",
  "voucher has been applied to this order",
  "you have enjoyed a discount",
  "[CODE] already applied",
  "[CODE] applied",
  "code has been applied",
  "code successfully applied",
  "code will be applied on checkout page",
  "has been added to your cart",
  // Lookbehind, not a plain substring: "No discount applied by SAVE20" contains
  // "discount applied", so the bare form read a FAILURE as a success and forced
  // `applied: true` on it. 10 such rows over 2 days, every one with savings <= 0.
  // `stringCompare` compiles any entry containing a backslash as a regex, and
  // only the backend evaluates these lists at runtime (Node 20) — the synced
  // webapp/extension copies have no callers — so lookbehind is safe here.
  "(?<!no )\\bdiscount applied",
  `${EXACT_CONSTANT}[CODE] is valid`,
  "success! offer applied",
  "[CODE] applied",
  "you have enjoyed a discount of more than",
  `${EXACT_CONSTANT}Coupon verified`,
  "Apply Apply [CODE] Subtotal",
  "Coupon code '[CODE]' applied",
  'Coupon code "[CODE]" already applied',
  "discount of £\\d+(\\.\\d{2})? has been applied to this order",
  "Congrats! You've saved \\$\\d+(\\.\\d{2})? off",
  "promo code was successfully applied",
  `${EXACT_CONSTANT}coupon applied`,
  'You used coupon code "[CODE]".',
  "Special Discount '[CODE]' is added to your shopping cart",
  `${EXACT_CONSTANT}discount code applied: [CODE]`,

  // German
  "code erfolgreich angewendet",
  "der code wurde hinzugefügt",
  "code erfolgreich hinzugefügt",

  // Spanish
  "el código de cupón se ha aplicado correctamente",
  "codice promozionale applicato con successo",

  "code promo appliqué avec succès",
  "nessun articolo scontabile in carrello",

  // French
  "Mes avantages grâce au code [CODE]",

  // Russian
  "Промокод успешно применен",

  // Polish — "coupon was successfully used". Found in the unrecognised-failure
  // bucket on 2026-09-30, i.e. successful applications recorded as failures.
  "kupon został pomyślnie użyty",
];

export const isConfirmedFailure = (code: string, message?: string) => {
  return stringCompare(code, confirmedCouponFailures, message);
};

export const isConfirmedSuccess = (code: string, message?: string) => {
  return stringCompare(code, knownCouponSuccessMessages, message);
};

export const isConfirmedNotApplicableMessage = (
  code: string,
  message?: string,
) => {
  return stringCompare(code, notApplicableCouponMessages, message);
};

export const stringCompare = (
  couponCode: string,
  strArray: string[],
  message?: string,
) => {
  if (!message) return false;

  // Normalize whitespace: remove tabs, newlines, and collapse multiple spaces
  const normalizedMessage = message.replace(/\s+/g, " ").trim().toLowerCase();
  const compareArray = strArray.map((str) =>
    str.replace(/\[CODE\]/g, couponCode).toLocaleLowerCase(),
  );

  return compareArray.some((str) => {
    if (str.startsWith("!!")) {
      return str.slice(2) === normalizedMessage;
    }

    // Check if string contains regex pattern (indicated by backslashes like \d)
    if (str.includes("\\")) {
      try {
        const regex = new RegExp(str, "i");
        return regex.test(normalizedMessage);
      } catch {
        // Fall back to string includes if regex is invalid
        return normalizedMessage.includes(str);
      }
    }

    return normalizedMessage.includes(str);
  });
};

/**
 * The deliberately invalid code every capture run finishes on.
 *
 * Applying it must FAIL. When a merchant reports it as applied, that merchant's
 * success detection is wrong — which is the "applied, saved 0" false positive
 * this whole check exists to catch — so the journey run says so rather than
 * passing.
 */
export const FAILURE_PROBE_COUPON = "SAVE0";

/**
 * A failure message that is actually markup or script, not text a shopper would
 * read. It means the failureAlertSelector matched a <script>/<style> node or a
 * template fragment, so the capture is wrong — the coupon result tells us
 * nothing and the selector needs re-deriving. Treated as a system error rather
 * than a merchant rejection.
 */
export const looksLikeCapturedCode = (message?: string | null): boolean => {
  const t = String(message ?? "").trim();
  if (!t) return false;
  return (
    /\$\(|jQuery\(|function\s*\(|=>|document\.|window\./.test(t) ||
    /<\/?(script|style|div|span|template)\b/i.test(t) ||
    /\.val\(|\.html\(|\.text\(|addEventListener|querySelector/.test(t) ||
    // [\s\S] rather than the `s` flag: this file also compiles for the webapp
    // and the extension, which target ES5.
    /^[{[][\s\S]*[}\]]$/.test(t) ||
    (/;\s*$/.test(t) && /[(){}]/.test(t))
  );
};
